import { Pipe, PipeTransform } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TTest } from '../../types';

@Pipe({
  name: 'testRevisionFilter',
  standalone: false
})
export class TestRevisionFilterPipe implements PipeTransform {
  transform(
    tests: TTest[],
    ...args: [FormControl, string, FormGroup]
  ): { name: number; value: string }[] {
    if (args[0]?.invalid) {
      return [];
    }

    const findTest = tests.find((test) => test.uid === args[1]);
    return (
      findTest?.revisions.map((revision) => ({
        name: revision.number,
        value: revision.uid
      })) ?? []
    );
  }
}
